var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import ContentCard from "../Card.vue";
import Cover from "../Cover.vue";
import GenericContent from "./Generic.vue";
import Teaser from "./Teaser.vue";
import ImageContent from "./Image.vue";
var ContentContainer = /** @class */ (function (_super) {
    __extends(ContentContainer, _super);
    function ContentContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ type: String })
    ], ContentContainer.prototype, "title", void 0);
    __decorate([
        Prop({ type: String })
    ], ContentContainer.prototype, "subtitle", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], ContentContainer.prototype, "children", void 0);
    __decorate([
        Prop({ type: Number, default: 1 })
    ], ContentContainer.prototype, "columns", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], ContentContainer.prototype, "fluid", void 0);
    ContentContainer = __decorate([
        Component({
            name: "ContentContainer",
            components: {
                ContentCard: ContentCard,
                GenericContent: GenericContent,
                Teaser: Teaser,
                Cover: Cover,
                ImageContent: ImageContent
            }
        })
    ], ContentContainer);
    return ContentContainer;
}(Vue));
export default ContentContainer;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Content/Container.vue
// module id = 172
// module chunks = 7 8 9